import { render, staticRenderFns } from "./RecommendManagement.vue?vue&type=template&id=7fd0f672"
import script from "./RecommendManagement.vue?vue&type=script&lang=js"
export * from "./RecommendManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports